import { ActionContext } from 'vuex';
import { Store } from '@/models/Store';
interface Ui {
  pickSolved: boolean;
  showIVRContact: boolean;
  showPolicy: boolean;
}
const state: Ui = {
  pickSolved: false,
  showIVRContact: true,
  showPolicy: true
};

const getters = {
  getPickSolved (moduleState: Ui) {
    return moduleState.pickSolved;
  },
  showIVRContact (moduleState: Ui) {
    return moduleState.showIVRContact;
  },
  showPolicy (moduleState: Ui) {
    return moduleState.showPolicy;
  }
};

const mutations = {
  setPickSolved (moduleState: Ui, type: boolean) {
    moduleState.pickSolved = type;
  },
  setShowIVRContact (moduleState: Ui, showIVRContact: boolean) {
    moduleState.showIVRContact = showIVRContact;
  },
  setShowPolicy (moduleState: Ui, showPolicy: boolean) {
    moduleState.showPolicy = showPolicy;
  }
};

const actions = {
  changePickSolved (action: ActionContext<Ui, Store>, type: boolean) {
    action.commit('setPickSolved', type);
  },
  updateShowIVRContact (action: ActionContext<Ui, Store>, showIVRContact: boolean) {
    action.commit('setShowIVRContact', showIVRContact);
  },
  updateShowPolicy (action: ActionContext<Ui, Store>, showPolicy: boolean) {
    action.commit('setShowPolicy', showPolicy);
  }
};

export const ui = {
  state,
  getters,
  mutations,
  actions
};
